(() => {
  const script = document.currentScript;

  if (!script || window.growthlabKlaviyoLanguageSync) return;

  window.growthlabKlaviyoLanguageSync = true;

  const root = document.documentElement;
  const siteLanguage = script.dataset.siteLanguage === 'English' ? 'English' : 'French';
  const customerEmail = script.dataset.customerEmail?.trim() || '';
  const companyId = script.dataset.klaviyoCompanyId?.trim() || '';
  const syncError = script.dataset.syncError || '';
  const onsiteScriptSelector = 'script[src*="static.klaviyo.com/onsite/js/"]';
  const identifyTimeout = 2500;

  root.dataset.siteLanguage = siteLanguage;

  let onsiteScript = document.querySelector(onsiteScriptSelector);

  if (!onsiteScript && companyId) {
    onsiteScript = document.createElement('script');
    onsiteScript.async = true;
    onsiteScript.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${encodeURIComponent(companyId)}`;
    document.head.append(onsiteScript);
  }

  const klaviyoAvailable = () => {
    return Boolean(
      companyId ||
      onsiteScript ||
      typeof window.klaviyo?.identify === 'function'
    );
  };

  root.dataset.klaviyoLanguageSync = klaviyoAvailable() ? 'ready' : 'missing-onsite';

  const identify = (email) => {
    if (!email || !klaviyoAvailable()) return Promise.resolve(false);

    window.klaviyo = window.klaviyo || [];
    root.dataset.klaviyoLanguageSync = 'identifying';

    return new Promise((resolve) => {
      let completed = false;

      const finish = (identified = true) => {
        if (completed) return;
        completed = true;
        window.clearTimeout(timeoutId);
        root.dataset.klaviyoLanguageSync = identified ? 'identified' : 'timed-out';
        resolve(identified);
      };

      const timeoutId = window.setTimeout(() => finish(false), identifyTimeout);
      const properties = { email, siteLanguage };

      try {
        if (typeof window.klaviyo.identify === 'function') {
          const result = window.klaviyo.identify(properties, () => finish(true));

          if (result && typeof result.then === 'function') {
            result.then(() => finish(true)).catch(() => finish(false));
          }
        } else {
          window.klaviyo.push(['identify', properties, () => finish(true)]);
        }
      } catch (error) {
        finish(false);
      }
    });
  };

  const getFormIdentity = (form) => {
    const newsletterEmail = form.querySelector('input[name="contact[email]"]');
    const newsletterTags = form.querySelector('input[name="contact[tags]"]')?.value || '';
    const isNewsletter = form.id.startsWith('NewsletterForm-') || newsletterTags
      .split(',')
      .some((tag) => tag.trim().toLowerCase() === 'newsletter');

    if (newsletterEmail && isNewsletter) {
      return {
        email: newsletterEmail.value.trim(),
        input: newsletterEmail,
        requiresIdentification: true
      };
    }

    const accountEmail = form.querySelector('input[name="customer[email]"]');
    const formPath = new URL(form.action, window.location.origin).pathname;
    const isAccountForm = /\/account(?:\/login)?\/?$/.test(formPath);

    if (!accountEmail || !isAccountForm) return null;

    return {
      email: accountEmail.value.trim(),
      input: accountEmail,
      requiresIdentification: /\/account\/?$/.test(formPath)
    };
  };

  const showSyncError = (form, input) => {
    let message = form.querySelector('[data-klaviyo-language-error]');

    if (!message) {
      message = document.createElement('p');
      message.dataset.klaviyoLanguageError = '';
      message.setAttribute('role', 'alert');
      form.append(message);
    }

    message.textContent = syncError;
    input.focus();
  };

  const clearSyncError = (form) => {
    form.querySelector('[data-klaviyo-language-error]')?.remove();
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || form.dataset.klaviyoLanguagePending === 'true') return;

    const identity = getFormIdentity(form);

    if (!identity?.email) return;

    event.preventDefault();
    form.dataset.klaviyoLanguagePending = 'true';
    clearSyncError(form);

    const identified = await identify(identity.email);

    if (!identified && identity.requiresIdentification) {
      form.dataset.klaviyoLanguagePending = 'false';
      showSyncError(form, identity.input);
      return;
    }

    HTMLFormElement.prototype.submit.call(form);
  }, true);

  if (customerEmail) identify(customerEmail);
})();
